import { render, staticRenderFns } from "./NewSubjectDialog.vue?vue&type=template&id=05b01834&scoped=true"
import script from "@/views/Subjects/Dialogs/NewSubjectDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Subjects/Dialogs/NewSubjectDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Subjects/Dialogs/new-subject-dialog.scss?vue&type=style&index=0&id=05b01834&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b01834",
  null
  
)

export default component.exports